import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Box, Text, Button, Checkbox, Link } from "@chakra-ui/react";
import { FaCcVisa, FaUniversity, FaDonate } from "react-icons/fa";
import { Link as ReactRouterLink } from "react-router-dom";
import { T_C_ROUTE } from "src/routes";

type props = {
  quotation: Quotation;
  selectMethod: (qId: number, name: string) => void;
  setHeighPrices: React.Dispatch<React.SetStateAction<boolean>>;
  setFileName: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSubscriptionData: React.Dispatch<
    React.SetStateAction<
      | {
          quotationId?: number;
          paymentMethod?: string;
          proveUrl?: string;
          nationalityProofUrl?: string;
        }
      | undefined
    >
  >;
  subscribeHeighPrice: (subData: {}) => void;
  setChangeQuotationSectionVisibility: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  handleOpening: (quotation: Quotation) => void;
  processing: boolean;
};

type Quotation = {
  id?: number;
  duration?: number;
  price?: number;
  currency?: "USD";
  region?: string;
  selected?: string;
};

const currencyMap = {
  USD: "$",
};

const paymentMethods = [
  { name: "card", Icon: FaCcVisa, color: "#6c5fe3" },
  { name: "purchase", Icon: FaDonate, color: "#0abf25" },
  { name: "bank", Icon: FaUniversity, color: "#f5b464" },
];

const SubscriptionCard = ({
  quotation,
  processing,
  selectMethod,
  setHeighPrices,
  setFileName,
  setSubscriptionData,
  subscribeHeighPrice,
  setChangeQuotationSectionVisibility,
  handleOpening,
}: props) => {
  const [agreeOnTermsAndConditions, setAgreeOnTermsAndConditions] =
    useState<boolean>(false);

  return (
    <Box
      key={quotation.id}
      display="flex"
      flexDir="column"
      alignItems="center"
      padding="30px 0"
      borderRadius="15px"
      backgroundColor="white"
      boxShadow="0 2px 10px 2px silver"
      margin={{
        base: "30px 0 !important",
        lg: "30px !important",
      }}
      width={{ base: "300px", md: "350px" }}
      position="relative"
      overflow="hidden"
    >
      <Box padding="0 30px">
        <Text fontSize="36px" fontWeight="bold" color="brand.900">
          {quotation.duration} <FormattedMessage id="year" />
        </Text>
      </Box>
      <Box
        backgroundColor="brand.900"
        padding="30px 0"
        width="100%"
        marginTop="30px"
      >
        <Text
          textAlign="center"
          color="white"
          fontSize="28px"
          fontWeight="bold"
        >
          {quotation.price?.toFixed(2)}
          <sup>{currencyMap[quotation.currency!]}</sup>
        </Text>
      </Box>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        marginTop="30px"
      >
        {paymentMethods.map(({ name, Icon, color }) => (
          <Box
            title={name}
            key={name}
            margin="15px"
            width="80px"
            paddingTop="10px"
            display="flex"
            flexDir="column"
            alignItems="center"
            borderRadius="10px"
            background={name === quotation.selected ? "#b2caf7" : "white"}
            onClick={() => {
              selectMethod(quotation.id!, name);
            }}
            cursor="pointer"
            transition="150ms ease-out"
            _hover={{ background: "#b2caf7" }}
          >
            <Icon size={46} height="70px" width="70px" color={color} />
            <Text my={3} fontWeight="600">
              <FormattedMessage id={name} />
            </Text>
          </Box>
        ))}
      </Box>
      <Box marginTop="30px">
        {processing && (
          <Box margin="30px 0">
            <Text color="grey">
              <FormattedMessage id="wait" />
            </Text>
          </Box>
        )}
        {/* setFileName('proveUrl') */}
        <Button
          backgroundColor="brand.900"
          color="white"
          height="50px"
          _hover={{ filter: "brightness(120%)" }}
          onClick={() => {
            const isValidPrice =
              quotation.price === 245 || quotation.price === 375;

            if (isValidPrice) setHeighPrices(true);

            if (isValidPrice && quotation.selected === "bank")
              setFileName("proveUrl");

            if (isValidPrice && quotation.selected !== "bank") {
              // let selectedQoutation = quotations.find(
              //   (q) => q.selected
              // );
              // quotations.forEach(q => {
              //   if(q.selected){
              //     selectedPaymentMethod = q.selected
              //   }
              // })
              // console.log(selectedPaymentMethod)

              let subData = {
                quotationId: quotation.id,
                paymentMethod: quotation.selected,
              };
              setSubscriptionData({
                quotationId: quotation.id,
                paymentMethod: quotation.selected,
              });

              subscribeHeighPrice(subData);
              setChangeQuotationSectionVisibility(false);
              return;
            }
            handleOpening(quotation);
          }}
          disabled={
            !quotation.selected || processing || !agreeOnTermsAndConditions
          }
        >
          <FormattedMessage id="subscribe" />
        </Button>
      </Box>
      <Checkbox
        type="checkbox"
        name="complete"
        isChecked={agreeOnTermsAndConditions}
        onChange={() => setAgreeOnTermsAndConditions((prev) => !prev)}
        marginTop="20px"
      >
        <FormattedMessage id="agreeTerms" />{" "}
        <Link
          as={ReactRouterLink}
          to={T_C_ROUTE}
          color="brand.900"
          textStyle="smallBold"
          target="_blank"
          isExternal
        >
          <FormattedMessage id="t&c" />
        </Link>
      </Checkbox>
    </Box>
  );
};
export default SubscriptionCard;
